// import React, { useState } from 'react';
// import '../styles/ContactForm.css';

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     company: '',
//     email: '',
//     phone: '',
//     inquiryType: '',
//     message: ''
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const inquiryTypes = [
//     { value: 'partnership', label: '🤝 Partnership / Distributorship' },
//     { value: 'bulk-order', label: '📦 Bulk Order Inquiry' },
//     { value: 'support', label: '🛠️ Technical Support' },
//     { value: 'general', label: '📋 General Inquiry' },
//     { value: 'byob', label: '🎨 BYOB Program' },
//     { value: 'sample', label: '🔬 Sample Request' }
//   ];

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
    
//     // Simulate form submission
//     setTimeout(() => {
//       setIsSubmitting(false);
//       setIsSubmitted(true);
//       setFormData({
//         name: '',
//         company: '',
//         email: '',
//         phone: '',
//         inquiryType: '',
//         message: ''
//       });
      
//       setTimeout(() => {
//         setIsSubmitted(false);
//       }, 5000);
//     }, 1500);
//   };

//   return (
//     <section id="contact-form" className="contact-form-section">
//       <div className="contact-form-container">
        
//         <div className="contact-form-wrapper">
          
//           {/* Left Side - Form Info */}
//           <div className="contact-form-info">
//             <div className="contact-form-info-badge">Send us a Message</div>
//             <h2 className="contact-form-info-title">
//               Let's Start a <span>Conversation</span>
//             </h2>
//             <div className="contact-form-info-underline"></div>
//             <p className="contact-form-info-description">
//               Fill out the form and our team will get back to you within 24 hours. 
//               We're here to answer all your questions about partnerships, products, and support.
//             </p>
            
//             <div className="contact-form-info-features">
//               <div className="contact-form-info-feature">
//                 <span>✓</span> Quick Response within 24 hours
//               </div>
//               <div className="contact-form-info-feature">
//                 <span>✓</span> Dedicated relationship manager
//               </div>
//               <div className="contact-form-info-feature">
//                 <span>✓</span> Free consultation for partners
//               </div>
//               <div className="contact-form-info-feature">
//                 <span>✓</span> Confidential & secure
//               </div>
//             </div>
            
//             <div className="contact-form-info-stats">
//               <div className="contact-form-info-stat">
//                 <span className="contact-form-info-stat-number">50+</span>
//                 <span className="contact-form-info-stat-label">Happy Partners</span>
//               </div>
//               <div className="contact-form-info-stat-divider"></div>
//               <div className="contact-form-info-stat">
//                 <span className="contact-form-info-stat-number">98%</span>
//                 <span className="contact-form-info-stat-label">Satisfaction</span>
//               </div>
//               <div className="contact-form-info-stat-divider"></div>
//               <div className="contact-form-info-stat">
//                 <span className="contact-form-info-stat-number">24/7</span>
//                 <span className="contact-form-info-stat-label">Support</span>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Form */}
//           <div className="contact-form-right">
//             <div className="contact-form-card">
//               <div className="contact-form-header">
//                 <h3>Get in Touch</h3>
//                 <p>Fill the form below and we'll get back to you soon</p>
//               </div>

//               {isSubmitted ? (
//                 <div className="contact-form-success">
//                   <div className="contact-form-success-icon">✓</div>
//                   <h3>Thank You!</h3>
//                   <p>Your message has been sent successfully. Our team will contact you within 24 hours.</p>
//                 </div>
//               ) : (
//                 <form onSubmit={handleSubmit} className="contact-form">
//                   <div className="contact-form-row">
//                     <div className="contact-form-input-group">
//                       <label>Full Name *</label>
//                       <input
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                         placeholder="Enter your full name"
//                       />
//                     </div>
//                     <div className="contact-form-input-group">
//                       <label>Company Name *</label>
//                       <input
//                         type="text"
//                         name="company"
//                         value={formData.company}
//                         onChange={handleChange}
//                         required
//                         placeholder="Enter your company name"
//                       />
//                     </div>
//                   </div>

//                   <div className="contact-form-row">
//                     <div className="contact-form-input-group">
//                       <label>Email Address *</label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                         placeholder="enter@example.com"
//                       />
//                     </div>
//                     <div className="contact-form-input-group">
//                       <label>Phone Number *</label>
//                       <input
//                         type="tel"
//                         name="phone"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         required
//                         placeholder="Enter your mobile number"
//                       />
//                     </div>
//                   </div>

//                   <div className="contact-form-input-group">
//                     <label>Inquiry Type *</label>
//                     <select
//                       name="inquiryType"
//                       value={formData.inquiryType}
//                       onChange={handleChange}
//                       required
//                     >
//                       <option value="">Select Inquiry Type</option>
//                       {inquiryTypes.map((type) => (
//                         <option key={type.value} value={type.value}>
//                           {type.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="contact-form-input-group">
//                     <label>Message *</label>
//                     <textarea
//                       name="message"
//                       value={formData.message}
//                       onChange={handleChange}
//                       rows="5"
//                       required
//                       placeholder="Tell us about your requirements, questions, or anything you'd like to know..."
//                     ></textarea>
//                   </div>

//                   <button type="submit" className="contact-form-submit" disabled={isSubmitting}>
//                     {isSubmitting ? (
//                       <>
//                         <span className="contact-form-spinner"></span>
//                         Sending...
//                       </>
//                     ) : (
//                       <>
//                         Send Message
//                         <svg className="contact-form-submit-icon" viewBox="0 0 24 24" fill="none">
//                           <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                         </svg>
//                       </>
//                     )}
//                   </button>

//                   <p className="contact-form-note">
//                     * We respect your privacy. Your information is secure with us.
//                   </p>
//                 </form>
//               )}
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactForm;

import React, { useState } from 'react';
import '../styles/ContactForm.css';

const initialFormData = {
  name: '',
  company: '',
  email: '',
  phone: '',
  inquiryType: '',
  message: ''
};

const inquiryTypes = [
  { value: 'partnership', label: '🤝 Partnership / Distributorship' },
  { value: 'bulk-order', label: '📦 Bulk Order Inquiry' },
  { value: 'support', label: '🛠️ Technical Support' },
  { value: 'general', label: '📋 General Inquiry' },
  { value: 'byob', label: '🎨 BYOB Program' },
  { value: 'sample', label: '🔬 Sample Request' }
];

const ContactForm = () => {
  const [formData, setFormData] = useState(initialFormData);

  const whatsappNumber = '919748691530';

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Send form details to WhatsApp
  const handleSubmit = (e) => {
    e.preventDefault();

    const selectedInquiry = inquiryTypes.find(
      (type) => type.value === formData.inquiryType
    );

    const inquiryLabel = selectedInquiry
      ? selectedInquiry.label
      : formData.inquiryType;

    const whatsappMessage = `
*NEW CONTACT INQUIRY - PAPL HEAR*

*CUSTOMER DETAILS*
--------------------------
Name: ${formData.name}
Company: ${formData.company}
Email: ${formData.email}
Phone: ${formData.phone}

*INQUIRY DETAILS*
--------------------------
Inquiry Type: ${inquiryLabel}

*CUSTOMER MESSAGE*
--------------------------
${formData.message}

--------------------------
Submitted via PAPL HEAR Website
    `.trim();

    const whatsappURL =
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    // Open WhatsApp with prefilled message
    const whatsappWindow = window.open(
      whatsappURL,
      '_blank'
    );

    if (whatsappWindow) {
      whatsappWindow.opener = null;
    } else {
      // Fallback if popup is blocked
      window.location.href = whatsappURL;
    }

    // Do not reset the form here because WhatsApp
    // opening does not confirm the message was sent.
  };

  return (
    <section id="contact-form" className="contact-form-section">
      <div className="contact-form-container">

        <div className="contact-form-wrapper">

          {/* Left Side - Form Info */}
          <div className="contact-form-info">

            <div className="contact-form-info-badge">
              Send us a Message
            </div>

            <h2 className="contact-form-info-title">
              Let's Start a <span>Conversation</span>
            </h2>

            <div className="contact-form-info-underline"></div>

            <p className="contact-form-info-description">
              Fill out the form and connect with our team directly
              through WhatsApp. We're here to answer all your
              questions about partnerships, products, and support.
            </p>

            <div className="contact-form-info-features">

              <div className="contact-form-info-feature">
                <span>✓</span> Quick Response within 24 hours
              </div>

              <div className="contact-form-info-feature">
                <span>✓</span> Dedicated relationship manager
              </div>

              <div className="contact-form-info-feature">
                <span>✓</span> Free consultation for partners
              </div>

              <div className="contact-form-info-feature">
                <span>✓</span> Confidential & secure
              </div>

            </div>

            <div className="contact-form-info-stats">

              <div className="contact-form-info-stat">
                <span className="contact-form-info-stat-number">
                  50+
                </span>
                <span className="contact-form-info-stat-label">
                  Happy Partners
                </span>
              </div>

              <div className="contact-form-info-stat-divider"></div>

              <div className="contact-form-info-stat">
                <span className="contact-form-info-stat-number">
                  98%
                </span>
                <span className="contact-form-info-stat-label">
                  Satisfaction
                </span>
              </div>

              <div className="contact-form-info-stat-divider"></div>

              <div className="contact-form-info-stat">
                <span className="contact-form-info-stat-number">
                  24/7
                </span>
                <span className="contact-form-info-stat-label">
                  Support
                </span>
              </div>

            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="contact-form-right">

            <div className="contact-form-card">

              <div className="contact-form-header">
                <h3>Get in Touch</h3>
                <p>
                  Fill the form below and send your inquiry
                  directly through WhatsApp.
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                className="contact-form"
              >

                {/* Name and Company */}
                <div className="contact-form-row">

                  <div className="contact-form-input-group">
                    <label>Full Name *</label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="contact-form-input-group">
                    <label>Company Name *</label>

                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      required
                      placeholder="Enter your company name"
                    />
                  </div>

                </div>

                {/* Email and Phone */}
                <div className="contact-form-row">

                  <div className="contact-form-input-group">
                    <label>Email Address *</label>

                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="enter@example.com"
                    />
                  </div>

                  <div className="contact-form-input-group">
                    <label>Phone Number *</label>

                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter your mobile number"
                    />
                  </div>

                </div>

                {/* Inquiry Type */}
                <div className="contact-form-input-group">

                  <label>Inquiry Type *</label>

                  <select
                    name="inquiryType"
                    value={formData.inquiryType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">
                      Select Inquiry Type
                    </option>

                    {inquiryTypes.map((type) => (
                      <option
                        key={type.value}
                        value={type.value}
                      >
                        {type.label}
                      </option>
                    ))}

                  </select>
                </div>

                {/* Message */}
                <div className="contact-form-input-group">

                  <label>Message *</label>

                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    required
                    placeholder="Tell us about your requirements, questions, or anything you'd like to know..."
                  />

                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="contact-form-submit"
                >
                  <>
                    Send Message

                    <svg
                      className="contact-form-submit-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 12H19M19 12L13 6M19 12L13 18"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                </button>

                <p className="contact-form-note">
                  * Your details will be prepared as a WhatsApp
                  message. Please press Send in WhatsApp
                  to complete your inquiry.
                </p>

              </form>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ContactForm;
